// extracted by mini-css-extract-plugin
module.exports = {"lightblue":"#6595C7","mediumblue":"#114999","darkblue":"#0E1C39","orange":"#E74315","green":"#75C0BC","yellow":"#DCFF00","grey":"#D0D0D0","greyBG":"#EDEDED"};